/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeDashboardMilestoneStats } from './ChallengeDashboardMilestoneStats';
import {
    ChallengeDashboardMilestoneStatsFromJSON,
    ChallengeDashboardMilestoneStatsFromJSONTyped,
    ChallengeDashboardMilestoneStatsToJSON,
    ChallengeDashboardMilestoneStatsToJSONTyped,
} from './ChallengeDashboardMilestoneStats';

/**
 * 
 * @export
 * @interface ChallengeDashboardQuestStats
 */
export interface ChallengeDashboardQuestStats {
    /**
     * 
     * @type {string}
     * @memberof ChallengeDashboardQuestStats
     */
    questId: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeDashboardQuestStats
     */
    questName: string;
    /**
     * 
     * @type {Array<ChallengeDashboardMilestoneStats>}
     * @memberof ChallengeDashboardQuestStats
     */
    milestones: Array<ChallengeDashboardMilestoneStats>;
}

/**
 * Check if a given object implements the ChallengeDashboardQuestStats interface.
 */
export function instanceOfChallengeDashboardQuestStats(value: object): value is ChallengeDashboardQuestStats {
    if (!('questId' in value) || value['questId'] === undefined) return false;
    if (!('questName' in value) || value['questName'] === undefined) return false;
    if (!('milestones' in value) || value['milestones'] === undefined) return false;
    return true;
}

export function ChallengeDashboardQuestStatsFromJSON(json: any): ChallengeDashboardQuestStats {
    return ChallengeDashboardQuestStatsFromJSONTyped(json, false);
}

export function ChallengeDashboardQuestStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeDashboardQuestStats {
    if (json == null) {
        return json;
    }
    return {
        
        'questId': json['questId'],
        'questName': json['questName'],
        'milestones': ((json['milestones'] as Array<any>).map(ChallengeDashboardMilestoneStatsFromJSON)),
    };
}

export function ChallengeDashboardQuestStatsToJSON(json: any): ChallengeDashboardQuestStats {
    return ChallengeDashboardQuestStatsToJSONTyped(json, false);
}

export function ChallengeDashboardQuestStatsToJSONTyped(value?: ChallengeDashboardQuestStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questId': value['questId'],
        'questName': value['questName'],
        'milestones': ((value['milestones'] as Array<any>).map(ChallengeDashboardMilestoneStatsToJSON)),
    };
}

